module.exports = __webpack_public_path__ + "static/media/intro-2--dark.44e2e5c8.png";